module.exports = __webpack_public_path__ + "img/photo-0117.97f2d90b.jpg";